import { ORDERBOOK_URL } from "services/constants";

export const getAssetDistributionTaskDownloadURL = (
  assetDistributionTaskId: number,
  download: boolean,
) =>
  // `download` controls response type:
  // true => 1 - CSV response with detail file
  // false => 0 - JSON response for generating a PDF statement
  `${ORDERBOOK_URL}/asset-distribution-tasks/${assetDistributionTaskId}/export?download=${
    download ? 1 : 0
  }`;
